import React, { useState } from 'react'
import { useStyles } from './styles'
import ForumPost from 'components/set/ForumPost/ForumPost'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faUndo } from '@fortawesome/free-solid-svg-icons'
import ButtonGroup, { ButtonGroupItem } from 'components/common/ButtonGroup/ButtonGroup'
import { ForumEntry } from 'data/ForumEntry'

interface AskTheArtistViewerProps {
    acknowledgedEntries: ForumEntry[]
    unacknowledgedEntries: ForumEntry[]
    onAcknowledge: (entry: ForumEntry) => void
}

const tabItems = [
    { label: 'Unanswered', value: 'unanswered' },
    { label: 'Answered', value: 'answered' },
]

export const AskTheArtistViewer: React.FC<AskTheArtistViewerProps> = ({
    acknowledgedEntries,
    unacknowledgedEntries,
    onAcknowledge,
}) => {
    const classes = useStyles()
    const [selectedTab, selectTab] = useState<ButtonGroupItem>(tabItems[0])

    const viewAnswered = selectedTab.value === 'answered'
    const entryList = viewAnswered ? acknowledgedEntries : unacknowledgedEntries

    return (
        <div className={classes.widget}>
            <ButtonGroup className={classes.tabs} active={selectedTab} onChange={selectTab} items={tabItems} />
            {entryList.length ? (
                <div className={classes.list}>
                    {entryList.map(entry => (
                        <div key={entry._id} className={classes.question}>
                            <div className={classes.forumPostWrapper}>
                                <ForumPost readonly entry={entry} />
                            </div>
                            <div className={classes.checkbox} onClick={() => onAcknowledge(entry)}>
                                <FontAwesomeIcon icon={viewAnswered ? faUndo : faCheck} />
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={classes.noQuestions}>
                    No questions have been {viewAnswered ? 'answered' : 'asked'} yet
                </div>
            )}
        </div>
    )
}
